/****************************************************************
Alexander Self
8/23/17
Gang list:Displyas a list of gangs
****************************************************************/
import React from 'react';


const TeamList = ({ gangs, onClick, id }) => {
  return (
    <ul className="collection" id={id}>
      {
        gangs.map((g) => (
          <li key={g.gangId} className="collection-item avatar gang-list" onClick={() => onClick(g.gangId)}>
            <i className="material-icons circle">group</i>
            <span className="title">Team No: <b>{ g.gangId }</b></span>
            <p>Team Location: <b>{ g.gangLoc === 71 ? `${g.gangLoc} - Ka'u` : `${g.gangLoc} - Kea'au` }</b> <br />
               Team Count: <b>{ g.gangCount }</b>
            </p>
          </li>
        ))
      }
    </ul>
  );
};

export default TeamList;



/* END */



// WEBPACK FOOTER //
// ./src/components/teams/view/team_list.js